<template>
  <div class="order-list" :style="{ height: clientHeight+ 'px' }">
    <div class="order-soso fix">
      <div class="fl">
        订单信息：<z-input  size="240" @keyup.enter="soso" v-model.trim="orderKeyword" placeholder="订单号、礼品编号、物料编号"/>
      </div>

      <div class="ml20 fl">
        下单日期：<el-date-picker
          class="va-bt"
          v-model="sData"
					@change="onDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <z-select class="z-select-box-l" size="120" :zoptions="zp" v-model="zps" placeholder="请选择"></z-select>
      </div>

      <div class="ml20 fl">
        卖家信息：<z-input size="200" @keyup.enter="soso" v-model.trim="bargainerKeyword" placeholder="卖家编号、店铺名称" />
      </div>
      
      <div class="fl top20">
        订单状态：<z-select size="100" :zoptions="zoptions" v-model="status" placeholder="请选择"></z-select>
      </div>
      
      <z-button class="ml20 va-bt fl top20"  size="primary" @click="soso">搜索</z-button>
      <z-button class="ml20 va-bt fl top20"  @click="clickReset">重置</z-button>
    </div>
    
    <table class="list-box list-bg" v-if="OrderList.length > 0">
          <colgroup>
            <col width="370" />
            <col width="200" />
            <col width="200" />
            <col width="200" />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th>礼品信息</th>
              <th>订单总价</th>
              <th>订单状态</th>
              <th>订单其他信息</th>
              <th>操作</th>
            </tr>
          </thead>
    </table>

    <table class="list-box" v-for="(item,idx) in OrderList" :key="idx">
          <colgroup>
            <col width="370" />
            <col width="200" />
            <col width="200" />
            <col width="200" />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th class="first">订单号：{{item.code}}</th>
              <th class="first" colSpan="2">下单时间：{{item.orderTime}}</th>
              <th class="t-right" colSpan="2">
                <router-link :to="{ path: `/${item.vendorCode}` }"><i class="icons icon-shop"></i>{{item.vendorName}}</router-link>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="order-info o-list">
              <td class="first">

                <template v-for="(v,idx) in item.entries">
                  <template v-if="idx < 3">
                    <img v-if="v.imageUrl" :src="v.imageUrl" :key="v.productCode"/>
                    <img v-else src='../../assets/no-picture.png' :key="v.productCode"/>
                  </template>
                </template>

                <div class="order-dr">
                  <span>共{{item.entries.length}}种礼品</span>
                  <router-link :to="{ path: `/my/order/${item.code}` }">订单详情>></router-link>
                </div>
              </td>
              <td>总价：<IconJifen size="gray" :points="item.totalPrice" /></td>
              <td>{{ item.status | orderStatus}}</td>
              <td>
                <p>{{item.paymentType == 10 && '积分兑换'}}</p>
                <p>{{item.type == 10 ? '网站订单' : '手机订单'}}</p>
              </td>
              <td class="list-set">
                <router-link :to="{ path: `/my/order/${item.code}` }">订单详情</router-link>
                <a v-if="item.status == 20" @click="onOk(item.id)">确认收货</a>
                <a @click="onBatchAdd(item)">再次兑换</a>
              </td>
            </tr>
          </tbody>
      </table>
      <NoList v-if="OrderList.length == 0" title="暂没有订单" />

      <z-pager v-if="OrderList.length > 0" size='blue' :pageCount="totalPages" :clickHandler="onPage"></z-pager>

      <confirm titleTig="再次兑换" okText="去结算" closeText='知道了' :noCloseTag='noCloseTag' :message='message' @confirmok="confirmok" :shows="show"></confirm>
      <confirm titleTig="确认收货" okText="确定" :noCloseTag='true' :message='message' @confirmok="onOkTig" :shows="showOk"></confirm>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import NoList from "../../components/no-list.vue";
import IconJifen from "../../components/icon-jifen";
import Confirm from "../../components/confirm/main.vue";
import ZPager from "../../components/zPager";
import ZInput from "../../components/zInput";
import ZSelect from "../../components/zSelect";
import ZButton from "../../components/zButton";
const zpd = [
  { name: "自定义日期", id: 1 },
  { name: "不限日期", id: 2 },
  { name: "最近30天", id: 3 },
  { name: "最近90天", id: 4 },
  { name: "最近180天", id: 5 }
];
const zop = [
        { name: "不限", id: "" },
        { name: "待发货", id: 10 },
        { name: "待收货", id: 20 },
        { name: "已完成", id: 30 },
        { name: "已关闭", id: 40 }
      ]
const getTimes = [
  new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 30),
  new Date()
];
export default {
  computed: {
    ...mapGetters(["OrderList", "totalPages","clientHeight"])
  },
  components: {
    NoList,
    IconJifen,
    Confirm,
    ZPager,
    ZInput,
    ZButton,
    ZSelect
  },
  data() {
    return {
      vendorCode:'',
      sData: getTimes,
      num: 0,
      noCloseTag: false,
      show: false,
      showOk: false,
      message: "",
      open: true,
      zp: zpd,
      zps: zpd[2],
      zoptions: zop,
      orderKeyword: "", // 订单信息
      bargainerKeyword: "", // 卖家信息
      status: zop[0], //  订单状态，10：待发货，20：待收货，30：已完成，40：已关闭
      startDate: "", //     下单开始时间，格式yyyy-mm-dd
      endDate: "" //     下单结束时间，格式yyyy-mm-dd
    };
  },
  watch: {
    zps(val) {
      switch (Number(val.id)) {
        case 1:
          break;
        case 2:
          this.sData = "";
          break;
        case 3:
          this.sData = getTimes;
          break;
        case 4:
          this.sData = [
            new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 90),
            new Date()
          ];
          break;
        case 5:
          this.sData = [
            new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 180),
            new Date()
          ];
          break;
      }
    }
  },
  created() {
    this.soso();
  },
  methods: {
    onDate() {
      this.zps = zpd[0];
    },
    onDates(e) {
      let date = new Date(e);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();

      return [year, month, day].map(this.formatNumber).join("-");
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : "0" + n;
    },
    clickReset(){
      this.orderKeyword = ''
      this.bargainerKeyword = ''
      this.status = zop[0]
      this.zps = zpd[2];
      this.soso()
    },
    soso() {
      this.$store.commit("ORDER_SOSO_PAGE", {page: 1});
      this.$store.commit("ORDER_SOSO_PAGE_ONE");
      this.$store.commit("ORDER_SOSO_KEY", this.orderKeyword);
      this.$store.commit("ORDER_SOSO_BAR", this.bargainerKeyword);
      this.$store.commit("ORDER_SOSO_STATUS", this.status.id);
      this.$store.commit("ORDER_SOSO_DATE", [
        !this.sData ? "" : this.onDates(this.sData[0]),
        !this.sData ? "" : this.onDates(this.sData[1])
      ]);

      this.$store.dispatch("GETORDERLIST");
    },

    confirmok(o) {
      this.show = false;
      if(o){
        this.$router.replace({ path: `/${this.vendorCode}?open=1`});
      }
    },

    onPage(o,size) {
      // 分页
      this.$store.commit("ORDER_SOSO_PAGE", {page: o + 1, size:size});
      this.$store.dispatch("GETORDERLIST");
    },

    onBatchAdd(item) {
      var self = this;
      if (self.open == false) return;
      self.open = false;
      self.$store
        .dispatch("BATCH_ADD", {
          merchantCode: item.vendorCode,
          cartDetails: item.entries.map(v => {
            return { quantity: v.quantity, productCode: v.productCode };
          })
        })
        .then(r => {
          self.open = true;
          if (r.data.recode == 200) {
            self.show = true;
            self.vendorCode = item.vendorCode
            self.message = `订单(${item.code})里所有礼品已添加到兑换清单。已失效礼品无法结算。`;
          } else {
             this.$alert(r.data.msg || '错误：' + r.data.recode, '提示')
          }
        });
    },

    onOk(id) {
      this.showOk = true;
      this.message = `请确认是否收到货？确认收货后无法更改。`;
      this.okId = id;
    },

    onOkTig(o) {
      this.showOk = false;
      var self = this;
      if (self.open == false) return;
      self.open = false;
      if(o){
        self.$store.dispatch("ORDER_OK", this.okId).then(r => {
          self.open = true;
          if (r.data.recode == 200) {
            self.$store.dispatch("GETORDERLIST");
          } else {
            this.$message.error(r.data.msg || '错误：' + r.data.recode);
          }
        });
      }
      
    }
  }
};
</script>


<style>
.order-soso {
  margin-bottom: 20px;
  text-align: left;
}
.order-list {
  padding: 30px 20px 20px;
  width: 1140px;
  margin: auto;
  overflow-y: auto;
}
.order-dr {
  width: 76px;
  height: 76px;
  margin-right: 10px;
  border: 1px solid #eee;
  text-align: center;
  float: left;
  line-height: 22px;
  color: #999;
}
.t-right a {
  float: right;
  margin-right: 10px;
  color: #666;
}
.t-right a:hover {
  color: #169bd5;
}
.order-info img {
  float: left;
}
.o-list td {
  border: 1px solid #e7e7e7;
}
.order-info td {
  vertical-align: top;
}
.order-dr span {
  display: block;
  margin-top: 15px;
}
.order-dr a {
  display: block;
  color: #999;
}
.list-set a {
  display: block;
  cursor: pointer;
  margin-bottom: 6px;
}
.list-set a:hover {
  color: #169bd5;
}
.el-input__inner {
  height: 34px;
  line-height: 34px;
}
.el-range-editor.el-input__inner {
  padding: 0 10px;
}
.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 280px;
  border-radius: 4px 0 0 4px;
}
.el-date-editor .el-range-input,
.el-date-editor .el-range-separator {
  font-size: 12px;
}
.z-select-box-l {
  border-left: none;
}
.el-date-editor .el-range-input{
  width: 36%;
}
</style>
